import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import {
  clearActiveProject,
  getActiveProject,
  setActiveProject,
} from '../utils/projectStorage';

const ProjectContext = createContext(undefined);

export const ProjectProvider = ({ children }) => {
  const [activeProject, setActiveProjectState] = useState(() =>
    getActiveProject()
  );

  const refreshActiveProject = useCallback(() => {
    setActiveProjectState(getActiveProject());
  }, []);

  const selectProject = useCallback((project) => {
    setActiveProjectState(project || null);
    setActiveProject(project || null);
  }, []);

  const clearProject = useCallback(() => {
    setActiveProjectState(null);
    clearActiveProject();
  }, []);

  useEffect(() => {
    const onStorage = () => refreshActiveProject();
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [refreshActiveProject]);

  const value = useMemo(
    () => ({
      activeProject,
      selectProject,
      clearProject,
      refreshActiveProject,
      hasActiveProject: Boolean(activeProject),
    }),
    [activeProject, selectProject, clearProject, refreshActiveProject]
  );

  return (
    <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>
  );
};

export const useActiveProject = () => {
  const ctx = useContext(ProjectContext);
  if (!ctx) {
    throw new Error('useActiveProject must be used within a ProjectProvider');
  }
  return ctx;
};

